import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import ReactRouterPropTypes from 'react-router-prop-types';
import CommunicationChannelForm from './Form';
import SmartCard from '../../../shared/components/SmartCard';
import {
  changeLoadingFalse,
  changeLoadingTrue,
} from '../../../redux/actions/loadingActions';
import {
  comChannelListById,
  comChannelSave,
} from '../../../shared/queries/CommunicationChannel';
import GraphQL from '../../../GraphQL';
import { showNotificationAutoDestroy } from '../../../shared/components/ShowNotification';

const CommunicationChannelFormHandler = (props) => {
  const { match, t, history, dispatch } = props;
  const [dto, setDto] = useState({ id: 0 });
  const [formOn, setFormOn] = useState(false);

  function backClickHandler() {
    history.push('/minime/canal-comunicacao');
  }

  function showLoading() {
    dispatch(changeLoadingTrue());
  }

  function hideLoading() {
    dispatch(changeLoadingFalse());
  }

  function findById(id) {
    showLoading();
    const query = comChannelListById(id);
    GraphQL(query, {})
      .then((res) => {
        hideLoading();
        if (res.comChannelListByFilter) {
          const visibleTo = res.comChannelListByFilter[0].visibleTo.map(
            (item) => ({
              ...item,
              label: item.description,
              value: item.id,
            })
          );

          const employees = res.comChannelListByFilter[0].employees.map(
            (item) => ({
              ...item,
              label: item.name,
              value: item.id,
            })
          );

          const availablEmployees =
            res.comChannelListByFilter[0].availablEmployees.map((item) => ({
              ...item,
              label: item.name,
              value: item.id,
            }));

          setDto({
            ...res.comChannelListByFilter[0],
            visibleTo,
            availablEmployees,
            employees,
          });
        } else {
          showNotificationAutoDestroy(
            'danger',
            t('notifications.error'),
            t('notifications.record-not-found')
          );
          backClickHandler();
        }
      })
      .catch(() => {
        hideLoading();
        showNotificationAutoDestroy(
          'danger',
          t('notifications.error'),
          t('notifications.find-record-error')
        );
      });
  }

  const handleSubmit = (values) => {
    showLoading();
    const mutation = comChannelSave(values);
    GraphQL(mutation, {})
      .then((res) => {
        if (res.comChannelSave) {
          hideLoading();
          backClickHandler();
          showNotificationAutoDestroy(
            'success',
            t('success.title'),
            t('success.successfully-saved')
          );
        }
      })
      .catch(() => {
        hideLoading();
        showNotificationAutoDestroy(
          'danger',
          t('notifications.error'),
          t('errors.error-to-save')
        );
      });
  };

  useEffect(() => {
    if (match.params.id && match.params.id > 0) {
      if (dto.id !== parseInt(match.params.id, 0)) {
        findById(match.params.id);
      } else {
        setFormOn(true);
      }
    } else {
      setFormOn(true);
    }
  }, [dto]);

  return (
    <SmartCard title={t('mnt_communication_channel.title')}>
      {formOn ? (
        <CommunicationChannelForm
          onSubmit={handleSubmit}
          backHandler={backClickHandler}
          dto={dto}
          showLoading={showLoading}
          hideLoading={hideLoading}
        />
      ) : null}
    </SmartCard>
  );
};

CommunicationChannelFormHandler.propTypes = {
  t: PropTypes.func.isRequired,
  history: ReactRouterPropTypes.history.isRequired,
  dispatch: PropTypes.func.isRequired,
  match: ReactRouterPropTypes.match.isRequired,
};

export default withTranslation('common')(
  connect((state) => ({
    loading: state.loading,
  }))(CommunicationChannelFormHandler)
);
